/* 04 One case, every colour (sections/ez-colour-cycle.liquid, SPEC section 7). Homepage v2.
   Built on the shared runtime (assets/ez-home.js, window.EZH): EZH.stepper does the timing and the holds.
   - Every 2.4 s (section setting) the next colour: the case slides 26 px and crossfades, the ghost word drifts 12%,
     the italic name rolls up, the red progress line restarts. A swatch click jumps there and carries on.
   - Stops only for: the pause pill, pause all, keyboard focus inside (:focus-visible), less than 20% on screen,
     a hidden tab. Hover never stops it. Reduced motion: manual only (swatches), the pill is hidden.
   - Each cycling item is "waiting" (hidden, no transition), "is-on" or "is-out" (see ez-h-colour.css). An item is
     only ever is-out for as long as its leave transition runs, then it snaps back to waiting while hidden, so an
     outgoing name can never travel back through the incoming one. A fast second jump resets every other item at
     once, so at most two of each list exist on screen. Names go out then in (hidden from 0.2 s, then the roll).
   - Photos after the first have no src: they are warmed 700 px before the section scrolls in, and the next one is
     warmed at every step.
   - The colour name line is aria-live "polite" only while the cycle is stopped (WAI carousel pattern): a running
     cycle does not announce every 2.4 s; a keyboard user who presses a swatch (which holds the cycle) hears it. */
(function () {
  'use strict';
  var SEL = '[data-ez-h-colour]';
  var OUT_MS = { img: 900, word: 1500, name: 420 };

  function all(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }

  function swap(list, k, p, ms) {
    list.forEach(function (el, j) {
      if (j === k) {
        clearTimeout(el.__ccT);
        if (el.classList.contains('is-out')) el.classList.remove('is-out');
        if (!el.classList.contains('is-on')) el.classList.add('is-on');
      } else if (j === p && el.classList.contains('is-on')) {
        el.classList.remove('is-on');
        el.classList.add('is-out');
        clearTimeout(el.__ccT);
        el.__ccT = setTimeout(function () { el.classList.remove('is-out'); }, ms);
      } else if (el.classList.contains('is-on') || el.classList.contains('is-out')) {
        clearTimeout(el.__ccT);
        el.classList.remove('is-on', 'is-out');
      }
    });
  }

  function setup(root) {
    if (!root || root.__ezhColour || !window.EZH) return;
    var E = window.EZH;
    var imgs = all(root, '[data-cc-img]'), words = all(root, '[data-cc-word]'), names = all(root, '[data-cc-name]');
    var sws = all(root, '[data-cc-sw]');
    var bar = root.querySelector('[data-cc-bar]'), link = root.querySelector('[data-cc-link]');
    var linkName = root.querySelector('[data-cc-linkname]'), nameBox = root.querySelector('[data-cc-names]');
    var n = sws.length;
    if (n < 2 || imgs.length !== n) return;
    root.__ezhColour = true;

    function runBar() {
      if (!bar) return;
      bar.classList.remove('is-run');
      void bar.offsetWidth;                       // restart the animation from 0
      if (!E.reduced) bar.classList.add('is-run');
    }

    // "Shop this colour" follows the photo the shopper sees: on a timed step it switches once the incoming photo is
    // past half strength (measured: the two photos cross about .24 s into the .8 s crossfade); a swatch click switches
    // it at once (the shopper chose it)
    var linkT = 0;
    function setLink(k) {
      if (link) link.href = sws[k].getAttribute('data-url');
      if (linkName) linkName.textContent = ' (' + (sws[k].getAttribute('aria-label') || '') + ')';
    }
    function show(k, p, how) {
      E.warm(imgs[k]);
      E.warm(imgs[(k + 1) % n]);
      swap(imgs, k, p, OUT_MS.img);
      swap(words, k, p, OUT_MS.word);
      swap(names, k, p, OUT_MS.name);
      imgs.forEach(function (im, j) { if (j === k) im.removeAttribute('aria-hidden'); else im.setAttribute('aria-hidden', 'true'); });
      sws.forEach(function (b, j) {
        b.classList.toggle('is-on', j === k);
        b.setAttribute('aria-pressed', j === k ? 'true' : 'false');
      });
      clearTimeout(linkT);
      if (how === 'auto' && !E.reduced) linkT = setTimeout(function () { setLink(k); }, 240); else setLink(k);
      runBar();
    }

    var ms = parseInt(root.getAttribute('data-interval'), 10) || 2400;
    var s = E.stepper(root, { count: n, interval: ms, threshold: 0.2, show: show });
    root.__ezhColourStepper = s;

    function live(running) { if (nameBox) nameBox.setAttribute('aria-live', running ? 'off' : 'polite'); }
    live(s.mover.running);
    s.mover.listen(live);

    runBar();                                     // runs only while the section is not .is-paused
    E.onReduced(function () { runBar(); });

    sws.forEach(function (b, j) {
      b.addEventListener('click', function () {
        if (j === s.index) runBar();              // same colour: a full step from now, the bar starts again
        s.go(j);
      });
    });

    // warm every photo when the section is about 700 px away
    E.onVisible(root, function (v) { if (v) imgs.forEach(E.warm); }, { margin: '700px 0px', once: true });

    // theme editor: selecting a colour block shows it and holds the cycle until it is deselected
    root.addEventListener('shopify:block:select', function (e) {
      var j = sws.indexOf(e.target);
      if (j > -1) { s.go(j); s.mover.hold('editor', true); }
    });
    root.addEventListener('shopify:block:deselect', function () { s.mover.hold('editor', false); });
  }

  function init(scope) { all(scope || document, SEL).forEach(setup); }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
